export default "__VITE_ASSET__7eKrT$1M__"